import { Observable } from 'rxjs';
import { InjectionToken } from '@angular/core';
import { PageRequest } from '../../interfaces/pagination.interface';

export type DefaultQuery = {
  searchTerm?: string;
  [key: string]: any;
};

export type DefaultDataType = {
  id?: number | string;
  [key: string]: any;
};

export type PaginatedEndpoint<Q = DefaultQuery> = (
  req: PageRequest<Q>,
  query?: Q
) => Observable<unknown>;

export class FiltersServiceConfig {
  paginationKey? = defaultPaginationKeys.paginationKey;
  currentPage? = defaultPaginationKeys.currentPage;
  lastPage? = defaultPaginationKeys.lastPage;
  total? = defaultPaginationKeys.total;
}

export type DefaultPaginationKeys = {
  paginationKey: string;
  currentPage: string;
  lastPage: string;
  total?: string;
};

export type DefaultDataConfigType = {
  dataKey: string;
  idPath: string;
};

export const defaultPaginationKeys: DefaultPaginationKeys = {
  paginationKey: 'paginatorInfo',
  currentPage: 'currentPage',
  lastPage: 'lastPage',
  total: 'total',
};

export const defaultDataConfig: DefaultDataConfigType = {
  dataKey: 'data',
  idPath: 'id',
};

export const PAGINATION_CONFIG =
  /*@__PURE__*/ new InjectionToken<DefaultPaginationKeys>('pagination.config');
